module.exports = __webpack_public_path__ + "img/tag-ok.b33a913a.png";